import { render, staticRenderFns } from "./NpsBox.vue?vue&type=template&id=33e64012&lang=pug&"
import script from "./NpsBox.vue?vue&type=script&lang=js&"
export * from "./NpsBox.vue?vue&type=script&lang=js&"
import style0 from "./NpsBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports